


























































import Vue from 'vue';
import { mapGetters } from 'vuex';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import CourseBoardsShow from './CourseBoardsShow.vue';
import CourseBoardsGroup from './CourseBoardsGroup.vue';

export default Vue.extend({
  components: {
    pxCard,
    SquareEditOutlineIcon,
    ArrowRightIcon,
    CourseBoardsShow,
    CourseBoardsGroup,
    ChevronUp,
  },

  data: function() {
    return {
      courseId: null,
      showingGraduation: 'graduação',
      itShowingGraduation: true,
      openClassrooms: false,
      openBoards: false,
    };
  },

  computed: {
    ...mapGetters({
      course: 'currentCourse',
    }),
  },

  async mounted() {
    this.courseId = parseInt(this.$route.params.courseId);
    if (!this.courseId) this.courseId = 6; //TODO landing page

    await this.$store.dispatch('PULL_COURSE', this.courseId);
    await this.$store.dispatch(
      'PULL_BOARDS_GROUPS_BY_COURSE_ID',
      this.courseId,
    );
  },
  methods: {
    toggleBoards() {
      this.openBoards = !this.openBoards;
    },
    toggleClassrooms() {
      this.openClassrooms = !this.openClassrooms;
    },
  },
});
